// Initials and a colour for an avatar that has no image.
//
// Nothing in this system stores a picture: neither the UserPackage the backend
// assembles nor the `clients` table has a column for one, and there is no
// upload route. Initials are what can be built from what exists — a stock face
// would be inventing a person.

// Splits on spaces and on the separators an email uses, so both
// "Eula Osborn" and "eula.osborn@acme.com" come out as EO.
export function initialsOf(source) {
    const parts = String(source || '').trim().split(/[\s@._-]+/).filter(Boolean);
    if (!parts.length) return '?';
    return (parts[0][0] + (parts[1]?.[0] ?? '')).toUpperCase();
}

// How many pastel pairs live in design/tokens.css (--mm-tone-1..8).
const TONES = 8;

// The tone comes from the NAME and not from the id, so the same person keeps
// their colour across screens without anything being stored — and two rows of
// the same person in different lists never disagree.
//
// djb2, because it only has to spread short strings evenly and be identical on
// every render. Not a hash for anything that matters.
export function avatarTone(source) {
    const text = String(source || '');
    let hash = 5381;
    for (let i = 0; i < text.length; i += 1) {
        hash = ((hash << 5) + hash + text.charCodeAt(i)) | 0;
    }
    return (Math.abs(hash) % TONES) + 1;
}
